'use client';

import { Button } from '@wwe-portal/ui/components/button';
import { useGetInifiniteNews } from '../../providers/queries/news';
import { useState } from 'react';
import { ListSkeleton } from './list-skeleton';
import { ResponsiveNewsItem } from './responsive-news-item';

export const LoadMoreNewsSection = () => {
  const [enabled, setEnabled] = useState(false);
  const { data, fetchNextPage, isFetchingNextPage, isInitialLoading } =
    useGetInifiniteNews({
      enabled,
    });
  const allData = data?.pages.flatMap((page) => page) || [];
  return (
    <div className="mt-[10px] block md:mt-[30px]">
      <div className="grid grid-cols-1 gap-1 md:grid-cols-2 md:gap-8 2xl:grid-cols-3 min-[1620px]:grid-cols-4">
        {allData.map((item) => {
          return <ResponsiveNewsItem key={item.id} item={item} />;
        })}

        {isFetchingNextPage || isInitialLoading ? (
          <ListSkeleton num={12} />
        ) : null}
      </div>
      <div className="mt-[26px] flex justify-center">
        <Button
          className="bg-text800 text-text600 hover:bg-text800 hover:text-text500 h-[50px] w-[145px] px-[10px] font-normal"
          variant="none"
          onClick={() => {
            if (!enabled) {
              setEnabled(true);
              return;
            }
            fetchNextPage();
          }}
        >
          See More News
        </Button>
      </div>
    </div>
  );
};
